import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "login-page-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "login-page"
}
const _hoisted_3 = ["src", "poster"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "container login-page__content" }
const _hoisted_6 = { class: "login-page__content-inner grid flex flex--wrap flex--align-center" }
const _hoisted_7 = { class: "grid__item a4-12 c6-12 f6-6" }
const _hoisted_8 = {
  key: 0,
  class: "mb-24"
}
const _hoisted_9 = { class: "invisible" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h4" }, " Reset password ")
], -1 /* HOISTED */)
const _hoisted_12 = { class: "form__set" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form__label"
}, " Email ", -1 /* HOISTED */)
const _hoisted_14 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading_page)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($setup.login_globals.background_video_url)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 0,
                    class: "login-page__background-video",
                    src: $setup.login_globals.background_video_url,
                    poster: $setup.login_globals.background_poster_image ? $setup.login_globals.background_poster_image.url : null,
                    autoplay: "",
                    loop: "",
                    muted: ""
                  }, null, 8 /* PROPS */, _hoisted_3))
                : ($setup.login_globals.background_poster_image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: $setup.login_globals.background_poster_image.url,
                      alt: $setup.login_globals.background_poster_image.alt ?? $setup.login_globals.background_poster_image.filename,
                      class: "login-page__background-image"
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("form", {
                      class: "login-page__login-form",
                      onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.submitRequest && $options.submitRequest(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_router_link, {
                        to: { name: 'login' },
                        class: "login-page__logo"
                      }),
                      ($setup.login_globals && ( $setup.login_globals.title || $setup.login_globals.copy ))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("h1", _hoisted_9, _toDisplayString($setup.login_globals.title), 1 /* TEXT */),
                            _createCommentVNode(" eslint-disable vue/no-v-html "),
                            _createElementVNode("div", {
                              class: "typeset",
                              innerHTML: $setup.login_globals.copy
                            }, null, 8 /* PROPS */, _hoisted_10)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          id: "email",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.email) = $event)),
                          class: "form__input form__input--stretch",
                          type: "text",
                          name: "email"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.email]
                        ])
                      ]),
                      ($data.success_message)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($data.success_message), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: _normalizeClass(["button button--fill button--stretch button--large mt-32 mb-16", { 'button--loading' : $data.loading_reset }]),
                        type: "submit"
                      }, " Send reset link ", 2 /* CLASS */),
                      _createVNode(_component_router_link, {
                        to: { name: 'login' },
                        class: "a a--underline p--small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Back to login ")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ], 32 /* HYDRATE_EVENTS */)
                  ])
                ])
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}